import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Table } from "react-bootstrap";

export default function FormDocument(props){
    return(
        <>
            <div style={{textAlign : 'start', background:'#f1f4fa', marginTop:5, border:'1px solid rgba(0, 0, 0, 0.1)', borderRadius:'20px', padding:'10px'}}>
                <br />
                <p style={{textAlign:'start'}}className='p titre-steep'>Documents (pdf,docx)</p>
                <br />
                <Form.Label>Choisissez un fichier</Form.Label>
                <Table > 
                <tbody>  
                    {props.list.map((item, index) => {

                        return <tr key={item}>  
                                    
                                    <td style={{width:'90%', background:'rgb(241, 244, 250)'}}><Form.Control type="file"  onChange={props.ChangePJ} /> </td>

                                    <td style={{background:'rgb(241, 244, 250)'}}> 
                                        <p style={{background:'none', color:'red', border:'0px',cursor:'pointer'}} onClick={() => props.removeFichier((item, index))}>X </p>
                                        
                                    </td>
                                    
                                </tr>
                    })} 
                    <tr>
                        <td style={{ background:'rgb(241, 244, 250)'}}>
                            <p onClick={props.ajouterAuterFichier} style={{fontWeight:'700', fontSize:'15px', color:'green', textAlign:'start'}}>
                                    <FontAwesomeIcon icon={faPlus} /> Cliquez ici pour ajouter autres documents 
                                </p>
                        </td>
                    </tr>
                </tbody>
            </Table> 




                <br />
            </div>

            
        
        </>
    )
}